export type FrequencyOption = 'manual' | 'daily' | 'weekdays' | 'weekends' | 'custom';

export interface ScheduleUI {
  frequency: FrequencyOption;
  time: string; // "HH:mm"
  customCron: string;
}

const TIME_OPTIONS = Array.from({ length: 36 }, (_, i) => {
  const h = Math.floor(i / 2) + 6;
  const m = i % 2 === 0 ? '00' : '30';
  return `${String(h).padStart(2, '0')}:${m}`;
});

export function getTimeOptions(): string[] {
  return TIME_OPTIONS;
}

export function cronToScheduleUI(cron: string | null): ScheduleUI {
  if (!cron) {
    return { frequency: 'manual', time: '07:00', customCron: '' };
  }

  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) {
    return { frequency: 'custom', time: '07:00', customCron: cron };
  }

  const [min, hour, , , dow] = parts;

  // Only match exact patterns we generate
  if (min === '0' || min === '30') {
    const time = `${String(hour).padStart(2, '0')}:${min}`;

    if (dow === '*') {
      return { frequency: 'daily', time, customCron: '' };
    }
    if (dow === '1-5') {
      return { frequency: 'weekdays', time, customCron: '' };
    }
    if (dow === '6,0') {
      return { frequency: 'weekends', time, customCron: '' };
    }
  }

  return { frequency: 'custom', time: '07:00', customCron: cron };
}

export function scheduleUIToCron(ui: ScheduleUI): string | null {
  if (ui.frequency === 'manual') return null;
  if (ui.frequency === 'custom') {
    const trimmed = ui.customCron.trim();
    return trimmed || null;
  }

  const [h, m] = ui.time.split(':');
  const hour = parseInt(h, 10);
  const minute = parseInt(m, 10);

  switch (ui.frequency) {
    case 'daily':
      return `${minute} ${hour} * * *`;
    case 'weekdays':
      return `${minute} ${hour} * * 1-5`;
    case 'weekends':
      return `${minute} ${hour} * * 6,0`;
    default:
      return null;
  }
}

export function frequencyLabel(freq: FrequencyOption): string {
  switch (freq) {
    case 'manual':
      return 'Manuale';
    case 'daily':
      return 'Ogni giorno';
    case 'weekdays':
      return 'Lunedì–Venerdì';
    case 'weekends':
      return 'Sabato–Domenica';
    case 'custom':
      return 'Personalizzato';
  }
}
